<app-navbar></app-navbar>
<app-admin-hotel-slide></app-admin-hotel-slide>
<app-footer></app-footer>